module.exports = __webpack_public_path__ + "24a8fb2fb26787709f65a7aa78e13f44.png";